import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InfoModalEvent, RadioGroupItemProps } from '@nx-ng/types';

@Component({
  selector: 'nx-ng-local-radio-group',
  templateUrl: './local-radio-group.component.html',
  styleUrls: ['./local-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => LocalRadioGroupComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalRadioGroupComponent<T> implements ControlValueAccessor {
  @Input()
  groupName?: string;

  @Input()
  standard: RadioGroupItemProps<T>[] = [];

  @Input()
  labelledBy = '';

  @Input()
  describedBy = '';

  @Input()
  hasError = false;

  @Input()
  separatorLabelKey?: string;

  @Input()
  additional?: RadioGroupItemProps<T>[] = [];

  @Input()
  selected?: T;

  @Input()
  showMoreInfoText = true;

  @Output()
  selection: EventEmitter<T> = new EventEmitter<T>();

  @Output()
  action: EventEmitter<InfoModalEvent> = new EventEmitter<InfoModalEvent>();

  @Output()
  blur: EventEmitter<void> = new EventEmitter<void>();

  private localValue: T | undefined = undefined;
  private touched = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set value(value: T | undefined) {
    this.localValue = value;
    this.onChange(value);
  }

  get value(): T | undefined {
    return this.localValue;
  }

  onChange = (event: any) => {};
  onTouch = () => {};

  writeValue(value: T) {
    this.localValue = value;
    this.selected = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  markAsTouched() {
    if (!this.touched) {
      this.touched = true;
      this.onTouch();
    }
  }

  handleAction(action: InfoModalEvent): void {
    this.action.emit(action);
  }

  handleSelection(newValue: T): void {
    this.value = newValue;
    this.selection.emit(newValue);
  }

  handleBlur() {
    this.markAsTouched();
    this.blur.emit();
  }

  trackByFn(_index: number, item: RadioGroupItemProps<T>) {
    return item.titleKey;
  }
}
